import { createContext, useContext } from 'react';

import type { CustomTestsContextValue } from 'pages/custom_tests_v1/CustomTests';

export const CustomTestsContext = createContext({} as CustomTestsContextValue);
CustomTestsContext.displayName = 'CustomTestsContext';

export const useCustomTests = () => useContext(CustomTestsContext);